import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutInboundTenderList extends Layout {
    buttonAdditionalInfo: Button;
    panel1: Panel;
    sourceEdiOrder: DataSource;
    sourceEdiorderProfile: DataSource;
    tableInboundTenders: Table;
}
